import { debounce, get } from 'lodash'
import { validate } from 'lib/utils/ssn'

import Client from 'components/Client'

import ssnIsUnique from 'graphql/validate/ssnIsUnique.gql'
import domainIsValid from 'graphql/validate/domainIsValid.gql'
import registrationNumberIsValid from 'graphql/validate/registrationNumberIsValid.gql'
import isDuplicateEmail from 'graphql/validate/isDuplicateEmail.gql'
import AppError, { logException } from 'lib/errors'
import { fetchPolicy } from 'lib/apolloFetchPolicy'

export function validateSsn (ssn, exception = false) {
    return validate(ssn) || (exception && exception === ssn)
}

export const validateSsnIsUnique = async (ssn) => {
    const result = await Client.query({
        query: ssnIsUnique,
        variables: { ssn: ssn }
    }).catch(error => logException(error))

    // return ssn !== '081181-9984'
    return get(result, 'data.ssnIsUnique', null)
}

export const validateDomain = async (domain) => {
    const result = await Client.query({
        query: domainIsValid,
        variables: { domain: domain },
    }).catch(error => logException(error))

    return get(result, 'data.domainIsValid', null)
}

export const validateBusinessId = (businessId) => {
    const re = /^([0-9]{7})-([0-9A-Z]{1})$/i
    return re.test(businessId)
}

export const validateRegistrationNumber = async (regNumber, vertical) => {
    return Client.query({
        query: registrationNumberIsValid,
        variables: { regNumber: regNumber, vertical: vertical },
    })
}

export const debounceValidateRegistrationNumber = debounce(async (regNumber, vertical) => {
    const res = await validateRegistrationNumber(regNumber, vertical)
        .catch(err => {
            const appError = AppError.readFromApolloError(err)
            const message = `errors:omanettix.${appError.code}.message`

            return { error: message }
        })

    if (res && res.data) {
        return undefined
    } else if (res && res.error) {
        return res.error
    }
}, 500, { leading: true })

export const validateAccountWithEmailAlreadyExists = async (email) => {
    const result = await Client.query({
        query: isDuplicateEmail,
        variables: { email: email },
        fetchPolicy: fetchPolicy.NETWORK_ONLY,
    }).catch(error => logException(error))

    return result && !result.data.isDuplicateEmail
}
